// extracted by mini-css-extract-plugin
module.exports = {"skill":"Skills-module--skill--3vOim"};